import React from 'react';
import PropTypes from 'prop-types';
import MuiChip from '@material-ui/core/Chip';
import Avatar from 'components/atoms/Avatar/Avatar';
import { useChipStyles } from 'components/atoms/Chip/chipStyles';

/**
 * Default Chip component based on https://material-ui.com/components/chips/
 * @param {*} props All possible props can be found in docs https://material-ui.com/components/chips/#api
 */
export default function Chip(props) {
  const { label, ...rest } = props;
  const classes = useChipStyles();

  return (
    <MuiChip
      color="primary"
      clickable
      avatar={
        label && <Avatar>{label.split(' ').map((i) => i.charAt(0))}</Avatar>
      }
      variant="outlined"
      label={label}
      className={classes.root}
      {...rest}
    />
  );
}

Chip.propTypes = {
  /**
   * Represents text to display
   */
  label: PropTypes.string,
};
